export class YouthPhotoConfig {
    public static EndPoint = {
        UploadKey: '/common/files/upload-key',
        addYouthPhoto: '/jjis/youth-photo/addYouthPhoto',
        getYouthPhoto: '/jjis/youth-photo/getYouthPhoto/{youthid}',
        removeYouthPhoto: '/jjis/youth-photo/removeYouthphoto/{youthid}',
        getbyPhotoId: '/jjis/youth-photo/getYouthPhotoById/{photoid}',
        updateYouthPhoto: '/jjis/youth-photo/updateYouthPhoto',
        getPhysicalDescription: '/jjis/youth-photo/getPhysicalDescription/{youthid}',
        getPhysicalLookUp: '/platform/master/lookup/services/jjisMaster',
        getActivePage: '/platform/page-designer/pageversion/{id}',
    }
}
